import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import style from "./snappShopCard.module.scss";
import SwitchButton from "../../SelectionControls/Switch/Switch";
import EditDropDown from "../../Dropdown/EditDropDown/DropDown"
import Button from "../../Button/button"
import EditInput from "../../EditInput/input"
import RangeSlider from "../../pricing/rangeSlider/rangeSlider"
import toPersianNumber from "../../../helpers/actions/toPersianNumber"
import numberWithCommas from "../../../helpers/actions/numberWithCommas"
import toEnglishNumber from "../../../helpers/actions/toEnglishNumber";
import momentJalaali from 'moment-jalaali';

const SnappShopCard = (props) => {

    const [cardDetail, setCardDetail] = useState({
        isEdited: false,
        moreInfo: false,
        margin_type_dropdown: [{ name: 'درصد', value: 'percent' }, { name: 'مبلغ', value: 'price' }, { name: 'قیمت نهایی', value: 'minPrice' }],
        isSendingEditData: false,
        pricingInfo: {
            ...props.data.robot,
            active: (props.data.robot && typeof props.data.robot.active != 'undefined' ? props.data.robot.active : false),
            variation_id: props.data._id,
            buy_price: props.data.robot && props.data.robot.buy_price ? props.data.robot.buy_price : '',
            min_margin_rate_type: props.data.robot && typeof props.data.robot.min_margin_rate_type != 'undefined' && props.data.robot.min_margin_rate_type ? props.data.robot.min_margin_rate_type : '',
            min_margin_rate: props.data.robot && props.data.robot.min_margin_rate ? props.data.robot.min_margin_rate : '',
        }
    })
    const convertDropDownValue = value => {
        let name = ''
        switch (value) {
            case 'minPrice':
                name = 'قیمت نهایی'
                break;
            case 'percent':
                name = 'درصد'
                break;
            case 'price':
                name = 'مبلغ'
                break;
        }
        return name
    }

    const determinBGColor = (inBuyBox, robotActive, hasError) => {
        let bg = 'notConnectedBG'
        if (robotActive) {
            if (hasError) {
                bg = 'hasError'
            } else {
                if (inBuyBox) {
                    bg = 'inBuyBoxBG'
                } else {
                    bg = 'outOfBuyBoxBG'
                }
            }
        }
        return bg
    }

    const defineLines = text => {
        let res = text
        if (text.length > 66) {
            res = text.slice(0, 55) + '...'
        }
        return res
    }

    const handleSwitchToggle = (tag, e, secondTag) => {
        let tmpData = cardDetail
        tmpData.pricingInfo[secondTag] = !e
        setCardDetail({ ...tmpData })
        setAllEditInfo()
    }

    const handleEditInfo = (tag, e) => {
        let tmpData = cardDetail
        if (tag == 'min_margin_rate_type' || tag == 'max_margin_rate_type') {
            tmpData.pricingInfo[tag] = e.value
        } else {
            tmpData.pricingInfo[tag] = toEnglishNumber((e.target.value).replaceAll(',', ''))
        }
        tmpData.isEdited = true
        setCardDetail({ ...tmpData })
    }

    const setAllEditInfo = async () => {
        if (cardDetail.pricingInfo.min_margin_rate_type && cardDetail.pricingInfo.max_margin_rate_type && cardDetail.pricingInfo.min_margin_rate && cardDetail.pricingInfo.max_margin_rate && cardDetail.pricingInfo.buy_price) {
            setCardDetail({ ...cardDetail, isSendingEditData: true })
            let params = {
                ...cardDetail.pricingInfo,
                buy_price: Number(cardDetail.pricingInfo.buy_price),
                min_margin_rate: Number(cardDetail.pricingInfo.min_margin_rate),
                max_margin_rate: Number(cardDetail.pricingInfo.max_margin_rate),
                size_of_price_decrease: cardDetail.pricingInfo.size_of_price_decrease ? Number(cardDetail.pricingInfo.size_of_price_decrease) : 100,
                roundness_digits: cardDetail.pricingInfo.roundness_digits ? cardDetail.pricingInfo.roundness_digits : 2,
                change_price_promotion: cardDetail.pricingInfo.change_price_promotion ? cardDetail.pricingInfo.change_price_promotion : true,
                specific_pricing_range: cardDetail.pricingInfo.specific_pricing_range ? Number(cardDetail.pricingInfo.specific_pricing_range) : 5,
                has_increase_price_permission: cardDetail.pricingInfo.has_increase_price_permission ? cardDetail.pricingInfo.has_increase_price_permission : false
            }
            let res = await props.editData(params)
            if (res && res.data && res.data.success) {
                // success message
            } else {
                props.toast('ویرایش محصول با اختلال رو‌به‌رو شد.')
            }
            setCardDetail({ ...cardDetail, isEdited: false, isSendingEditData: false, })
        } else {
            // setToast to fill the info
            props.toast('لطفا قیمت خرید، حداقل حاشیه سود و حداکثر حاشیه سود را به‌طور کامل وارد کنید.')
        }
    }

    const resetAllEditInfo = () => {
        let tmp = cardDetail
        tmp.pricingInfo = {
            ...props.data.robot,
            active: props.data.robot && typeof props.data.robot.active != 'undefined' ? props.data.robot.active : true,
            variation_id: props.data._id,
            ancillary_costs: 0,
            buy_price: props.data.robot && props.data.robot.buy_price ? props.data.robot.buy_price : '',
            min_margin_rate_type: props.data.robot && typeof props.data.robot.min_margin_rate_type != 'undefined' && props.data.robot.min_margin_rate_type ? props.data.robot.min_margin_rate_type : '',
            min_margin_rate: props.data.robot && props.data.robot.min_margin_rate ? props.data.robot.min_margin_rate : '',
        }
        tmp.isEdited = false
        setCardDetail({ ...tmp })
    }

    const deleteAll = type => {
        let tmp = cardDetail
        tmp.pricingInfo[type] = ''
        setCardDetail({ ...cardDetail })
    }

    return (
        <>
            <div
                className={`${style.wrapper} ${style[determinBGColor(((props.data.error_text && props.data.error_text != '' && props.data.robot && props.data.robot.active && props.data.snapp_active) ? false : props.data.in_buybox), (props.data.robot && props.data.robot.active && props.data.snapp_active), (props.data.error_text && props.data.error_text != '' && props.data.robot && props.data.robot.active && props.data.snapp_active))]}`}
            >
                <div className={style.innerFlexWrapper}>
                    <div className={style.titleWrapper}>
                        <a
                            href={`https://snappshop.co${props.data.url}`}
                            className={style.cardTitle}
                            target="_blank"
                        >
                            <div className={style.title}>
                                <p className={style.mainTitle} data-content={
                                    props.data.variation_attributes.length > 0 ?
                                        '(' + props.data.variation_attributes[0].value.title + ')'
                                        :
                                        ''
                                }>{defineLines(props.data.title)}</p>
                            </div>
                            <div className={style.vendorDetails}>
                                <p>{props.data.product_id}</p>
                                <p className={style.SNPSeprator}></p>
                                <p>SNP - {toPersianNumber(props.data.product_number)}</p>
                                <p className={style.SNPSeprator}></p>
                                <p>{props.data.discount ? 'تخفیف هوشمند' : '---'}</p>
                            </div>

                            {props.data.vendor && props.data.vendor.length > 0 && <div className={style.vendorDetails}>
                                <p>{props.data.vendor[0].title}</p>
                            </div>}
                        </a>
                    </div>
                    <div className={style.cardChannel}>
                        <SwitchButton
                            value={cardDetail.pricingInfo.active}
                            tag={'active'}
                            disabled={false}
                            onclick={handleSwitchToggle}
                        />
                    </div>

                    <div className={style.priceCard}>{(props.data.robot && props.data.robot.min_price) ? toPersianNumber(numberWithCommas(props.data.robot.min_price)) : '---'}</div>
                    <div className={style.priceCard}>{(props.data.robot && props.data.robot.max_price) ? toPersianNumber(numberWithCommas(props.data.robot.max_price)) : '---'}</div>
                    <div className={style.priceCard}>{props.data.price ? toPersianNumber(numberWithCommas(props.data.price)) : '---'}</div>
                    <div className={style.flexItem214}>
                        <div className={style.inputWrapper}>
                            <div className={style.firstInput}>
                                <EditDropDown
                                    tag='min_margin_rate_type'
                                    label=''
                                    placeHolder={cardDetail.pricingInfo.min_margin_rate_type ? convertDropDownValue(cardDetail.pricingInfo.min_margin_rate_type) : 'انتخاب'}
                                    dropdownList={cardDetail.margin_type_dropdown}
                                    hasSearchBox={false}
                                    hasCheckbox={false}
                                    handleSelect={handleEditInfo}
                                    deleteSelectedItems={() => deleteAll('min_margin_rate_type')}
                                    errorMessage=''
                                />
                            </div>

                            <div className={style.secondInput}>
                                <EditInput
                                    type="text"
                                    disabled={false}
                                    label=""
                                    placeholder=""
                                    tag="min_margin_rate"
                                    value={cardDetail.pricingInfo.min_margin_rate}
                                    error=''
                                    tooltip=''
                                    onchange={(e, tag) => handleEditInfo(e, tag)}
                                    onblur={() => console.log('')}
                                />
                            </div>

                        </div>
                        <div className={style.inputWrapper}>
                            <div className={style.growFlexItem}>
                                <EditInput
                                    type="text"
                                    disabled={false}
                                    label=""
                                    placeholder=""
                                    tag="buy_price"
                                    value={cardDetail.pricingInfo.buy_price}
                                    error=''
                                    tooltip=''
                                    onchange={(e, tag) => handleEditInfo(e, tag)}
                                    onblur={() => console.log('')}
                                />
                            </div>
                        </div>

                        <div>
                        </div>
                    </div>
                    <div className={style.listHeaderFlexItem32noMargin}>
                        {/* Check Mark */}
                        {cardDetail.isEdited && <div
                            className={style.editCheckMark}
                            onClick={() => setAllEditInfo()}
                        >
                            {cardDetail.isSendingEditData ? <div className={style.sendDataLoading}>
                                <div className={style.loader}></div>
                            </div>
                                :
                                <div className={style.editCheckMarkImage}></div>
                            }
                        </div>}
                        {/* Cross Mark */}
                        {cardDetail.isEdited && <div
                            className={style.editCrossMark}
                            onClick={() => resetAllEditInfo()}
                        >e</div>}
                    </div>
                    <div className={style.listHeaderFlexItem32noMargin}>
                        {/* More Info Mark */}
                        <div
                            className={!cardDetail.moreInfo ? style.moreInfoArrow : style.moreInfoArrowActive}
                            onClick={() => setCardDetail({ ...cardDetail, moreInfo: !cardDetail.moreInfo })}
                        >u</div>
                    </div>
                </div>

                {cardDetail.moreInfo && <div className={style.moreInfo}>
                    <div className={style.moreInfoInner}>
                        <div className={style.infoCol}>
                            <p className={style.label}>تعداد رقیب</p>
                            <p className={style.value}>{typeof props.data.other_seller_count != 'undefined' ? toPersianNumber(props.data.other_seller_count) : '---'}</p>
                        </div>
                        <div className={style.infoCol}>
                            <p className={style.label}>به‌روزرسانی</p>
                            <p className={style.value}>{toPersianNumber(momentJalaali(props.data.robot ? props.data.robot.last_change_price : props.data.created_at).format('HH:mm'))} - {toPersianNumber(momentJalaali(props.data.robot ? props.data.robot.last_change_price : props.data.created_at).format('jYYYY/jM/jD'))}</p>
                        </div>
                        <div className={style.infoCol}>
                            <p className={style.label}>وضعیت سود</p>
                            <div className={style.value}>
                                {(props.data.robot && props.data.robot.min_price && props.data.robot.max_price && props.data.price) ?
                                    <RangeSlider
                                        userProfit={(props.data.price < props.data.robot.min_price) ? props.data.robot.min_price : (props.data.price > props.data.robot.max_price ? props.data.robot.max_price : props.data.price)}
                                        minProfit={props.data.robot.min_price}
                                        maxProfit={props.data.robot.max_price}
                                    />
                                    :
                                    <p>نامشخص</p>
                                }
                            </div>
                        </div>
                        <div className={style.infoCol}>
                            <div className={style.proSetting}>
                                <Button
                                    disabled={false}
                                    tag="proSetting"
                                    type="noBorder"
                                    label="تنظیمات پیشرفته"
                                    onclick={() => props.openProSetting(props.data)}
                                />
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
            {(props.data.error_text && props.data.error_text != '' && (props.data.robot && props.data.robot.active) && props.data.snapp_active) &&
                <div className={style.errorText}>
                    <p>{toPersianNumber(numberWithCommas(props.data.error_text))}</p>
                </div>
            }
            {!props.data.snapp_active && <div className={style.snappDeactive}>
                <p>این تنوع در اسنپ‌ شاپ غیرفعال است.</p>
            </div>}
        </>
    )
}

export default withRouter(SnappShopCard)